export enum OperationPermissions {
  Arena = 'Arena',
  ArenaKPI = 'ArenaKPI',
  Invoice = 'Invoice',
  Expenditure = 'Expenditure',
  Buyer = 'Buyer',
  Contract = 'Contract',
  Expense = 'Expense',
  Document = 'Document',
  Report = 'Report',
  Administration = 'Administration',
  System = 'System',
  InvoiceInboxSign = 'InvoiceInboxSign',
  InvoiceFlow = 'InvoiceFlow',
  InvoiceQueue = 'InvoiceQueue',
}
